import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { BookAuthor } from "@modules/bookAuthors/types";
import { ListBookAuthorsQueryFilters } from "./types";

export async function getBookAuthorsService(filters?: ListBookAuthorsQueryFilters): Promise<BookAuthor[]> {
  try {
    const { data } = await api.get<ApiResponse<BookAuthor>>(`v1/book_contributor_admin/`, {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        ordering: "-id",
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching book categories:", error);
    throw error;
  }
}
